/**
* IBM Confidential
* Licensed Materials - Property of IBM
* (C) Copyright IBM Corp. 2020, 2024 All Rights Reserved.
* US Government Users Restricted Rights - Use, duplication or
* disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
* */

import React from 'react';
import PropTypes from 'prop-types';
import { Close } from '@carbon/react/icons';

var SidePanelCloseButton = function SidePanelCloseButton(_ref) {
  var activePanelId = _ref.activePanelId,
    closeButtonRef = _ref.closeButtonRef,
    focusOnLast = _ref.focusOnLast,
    onTabToNext = _ref.onTabToNext,
    iconDescription = _ref.iconDescription,
    onClose = _ref.onClose,
    onTabToPrev = _ref.onTabToPrev,
    panelId = _ref.panelId;
  return /*#__PURE__*/React.createElement("button", {
    className: "cds--btn cds--btn--icon-only cds--btn--ghost cpc--side-panel__button-close",
    onClick: onClose,
    ref: closeButtonRef,
    disabled: panelId !== activePanelId,
    type: "button",
    title: iconDescription,
    "aria-label": iconDescription,
    onKeyDown: function onKeyDown(e) {
      if (focusOnLast) {
        onTabToPrev(e);
      }
      onTabToNext(e);
    }
  }, /*#__PURE__*/React.createElement(Close, {
    "aria-label": iconDescription
  }));
};
SidePanelCloseButton.propTypes = {
  activePanelId: PropTypes.string.isRequired,
  closeButtonRef: PropTypes.shape({
    current: PropTypes.node
  }),
  focusOnLast: PropTypes.bool.isRequired,
  iconDescription: PropTypes.string.isRequired,
  onClose: PropTypes.func.isRequired,
  onTabToNext: PropTypes.func.isRequired,
  onTabToPrev: PropTypes.func.isRequired,
  panelId: PropTypes.string.isRequired
};
var SidePanelCloseButton$1 = SidePanelCloseButton;

export { SidePanelCloseButton$1 as default };
